/* eslint-disable @typescript-eslint/prefer-for-of */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import 'rxjs/add/operator/map';


@Injectable({ providedIn: 'root' })
export class StorageProvider {
  constructor(public http: HttpClient) {}

  isPrivateMode() {
    try {
      localStorage.setItem('try', 'storage');
    } catch (err) {
      return true;
    }
    return false;
  }

  setCookie(name: string, value: string) {
    const utcDate = new Date('2030-01-01').toUTCString();
    document.cookie = name + ' = ' + value + '; expires =' + utcDate;
  }

  setTempCookie(name: string, value: string) {
    const utcDate = new Date('2030-01-01').toUTCString();
    document.cookie = name + ' = ' + value;
  }

  getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setStorage(name: string, value: string) {
    try {
      localStorage.setItem(name, value);
    } catch (err) {
      this.setCookie(name, value);
    }
  }

  setSessionStorage(name: string, value: string) {
    try {
      sessionStorage.setItem(name, value);
    } catch (err) {
      this.setTempCookie(name, value);
    }
  }

  getStorage(name: string) {
    if (!this.isPrivateMode()) {
      if (!sessionStorage.getItem(name)) {
        return localStorage.getItem(name);
      } else {
        return sessionStorage.getItem(name);
      }
    } else {
      return this.getCookie(name);
    }
  }

  removeStorage(name: string) {
    if (!this.isPrivateMode()) {
      if (!sessionStorage.getItem(name)) {
        localStorage.removeItem(name);
      } else {
        sessionStorage.removeItem(name);
      }
    } else {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }
}
